export default "__VITE_ASSET__CpBAyk2r__"